"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6713],{

/***/ 96713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ multi_cards_carousel_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/multi-cards-carousel-tabs/multi-cards-carousel-tabs-component.scss.js




var StyledMultiCardsCarouselTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e7pgv5o0"
})("margin:0 auto;.sliding-card-grid-component{max-width:unset;.main-card-grid{display:flex;flex-direction:column;align-items:center;.cards-row{display:flex;justify-content:center;gap:20px;padding:10px;.small-card{width:292px;height:282px;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";text-align:center;perspective:1000px;border-radius:16px;.card-inner{position:relative;width:100%;height:100%;transition:transform 0.6s;transform-style:preserve-3d;border:1px solid ", colors/* default */.Z[color_consts.GAINSBORO_COLOR_NAME], ";border-radius:16px;}&:hover .card-inner{transform:rotateY(180deg);}.card-front,.card-back{position:absolute;width:100%;height:100%;backface-visibility:hidden;border-radius:16px;overflow:hidden;}.card-back{transform:rotateY(180deg);}.picture-component{border-radius:14px;display:flex;img{width:100%;}}}.wide-card{width:600px;height:282px;border:1px solid ", colors/* default */.Z[color_consts.GAINSBORO_COLOR_NAME], ";border-radius:16px;padding:24px 40px;.card-content{display:flex;flex-direction:column;justify-content:space-between;height:100%;.image-wrapper .picture-component{display:flex;img{", function(param) {
    var wideCardImageWidth = param.wideCardImageWidth;
    return wideCardImageWidth ? "width: ".concat(wideCardImageWidth) : "";
}, ";}}}.text-wrapper{display:flex;align-items:flex-end;color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";.paragraph-wrapper{.paragraph-body{", function(param) {
    var wideCardTextSize = param.wideCardTextSize;
    return wideCardTextSize ? "font-size: ".concat(wideCardTextSize) : "";
}, ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";line-height:1.4;}}}}}.cards-row:first-of-type{padding-top:20px;}.cards-row:last-of-type{padding-bottom:20px;}}.carousel-title-component{align-items:flex-end;justify-content:center;.core-title-container .core-title{width:1120px;font-weight:200;font-size:6rem;line-height:1.1;}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_GRID_WIDTH */.sk, "px){.sliding-card-grid-component{.carousel-title-component .core-title-container .core-title{width:880px;font-size:5rem;}.main-card-grid{.cards-row{.small-card{width:234px;height:226px;}.wide-card{width:476px;height:226px;.card-content .text-wrapper .paragraph-wrapper .paragraph-body{font-size:1.6rem;}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card-grid-base-component.js + 9 modules
var sliding_card_grid_base_component = __webpack_require__(74447);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/multi-cards-carousel-tabs/multi-cards-carousel-tabs-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var SubCard = function(param) {
    var image = param.image, backImage = param.backImage, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "small-card",
        style: {
            backgroundColor: colors/* default */.Z[backgroundColor]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card-inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-front",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: image
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-back",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: backImage
                    })
                })
            ]
        })
    });
};
var ProductCard = function(param) {
    var cardText = param.cardText, image = param.image, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "wide-card",
        style: {
            backgroundColor: colors/* default */.Z[backgroundColor]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: image
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: cardText
                    })
                })
            ]
        })
    });
};
var getCardsRow = function(subCards) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cards-row",
        children: subCards.map(function(card, index) {
            return card.isProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard, {
                cardText: card.cardText,
                backgroundColor: card.backgroundColor,
                image: card.image
            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCard, {
                image: card.image,
                backImage: card.backImage,
                backgroundColor: card.backgroundColor
            }, index);
        })
    });
};
var MultiCardsCarouselTabsComponent = function(param) {
    var cards = param.cards, carouselTitle = param.carouselTitle, wideCardImageWidth = param.wideCardImageWidth, wideCardTextSize = param.wideCardTextSize, carouselTitleAdvancedConfig = param.carouselTitleAdvancedConfig;
    var itemRenderer = function(card) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "main-card-grid",
            children: [
                getCardsRow(card === null || card === void 0 ? void 0 : card.firstRowCards),
                getCardsRow(card === null || card === void 0 ? void 0 : card.secondRowCards)
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMultiCardsCarouselTabsComponent, {
        wideCardImageWidth: wideCardImageWidth,
        wideCardTextSize: wideCardTextSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sliding_card_grid_base_component/* default */.Z, {
            cards: cards,
            cardsToShow: 1,
            customItemRenderer: itemRenderer,
            removeArrows: true,
            carouselTitle: _object_spread_props(_object_spread({}, carouselTitle, carouselTitleAdvancedConfig), {
                arrowColor: colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR]
            })
        })
    });
};
/* harmony default export */ var multi_cards_carousel_tabs_component = (MultiCardsCarouselTabsComponent);


/***/ })

}]);